import { LOCALE } from '../../common/constants';
import parchmentTransformer from './parchment';

export default function levelTransformer({ translations = {}, parchments, ...level }) {
  return {
    ...level,
    parchment: parchments && parchments.length > 0 ? parchmentTransformer(parchments[0]) : null,
    ...translations[LOCALE],
  };
}
